import React from 'react';
import PropTypes from 'prop-types';

import ActivityMenu from '@webex/react-component-activity-menu';

const propTypes = {
  activityTypes: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  onExit: PropTypes.func
};

const defaultProps = {
  onChange: () => {},
  onExit: () => {}
};

function SpaceActivityMenu({
  activityTypes,
  onChange,
  onExit
}) {
  function handleChange(activity) {
    return () => onChange(activity);
  }

  const buttons = activityTypes.map((a) => ({
    label: a.displayName,
    buttonClassName: a.buttonClassName,
    buttonType: a.buttonType,
    onClick: handleChange(a)
  }));

  return (
    <ActivityMenu
      buttons={buttons}
      onExit={onExit}
      showExitButton
    />
  );
}

SpaceActivityMenu.propTypes = propTypes;
SpaceActivityMenu.defaultProps = defaultProps;

export default SpaceActivityMenu;
